import { render, staticRenderFns } from "./index.vue?vue&type=template&id=28b8c9bb&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=28b8c9bb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b8c9bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28b8c9bb')) {
      api.createRecord('28b8c9bb', component.options)
    } else {
      api.reload('28b8c9bb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=28b8c9bb&scoped=true", function () {
      api.rerender('28b8c9bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cane-audio/index.vue"
export default component.exports